


export default {
    list: [],
    total: 0
};